import { Breakpoints, styled, css, ThemeDefinition } from '@vw-marketing/us-components';
interface StyledCardTileHoverProps {
  isAvailable?: boolean;
  isNewImage?: boolean;
  theme: ThemeDefinition;
}

export const StyledCardTileHover: any = styled.div<StyledCardTileHoverProps>`
  ${({ isNewImage, theme }) => {
    return css`
      cursor: pointer;
      color: ${theme.colors.content.primary};

      .image-wrapper {
        transition-delay: 0s;
        transition-duration: 0.5s;
        transition-property: transform;
        margin-top: 16px;
      }

      .text-wrapper {
        transition: color 0.5s;
      }

      &:hover {
        @media (min-width: ${Breakpoints.b960}px) {
          color: ${theme.colors.content.hover};

          .image-wrapper {
            transform: translate(0, -5px) ${isNewImage ? `scale(1)` : `scale(1.1)`};
          }
        }
      }
    `;
  }}
`;

interface StyledBackgroundProps {
  readonly backgroundColor: string;
  readonly backgroundImage?: string;
}

export const StyledBackground: any = styled.div<StyledBackgroundProps>`
  border-radius: ${({theme}) => theme.size.borderRadius.imageS};
  display: flex;
  flex-flow: wrap;
  max-height: 150px;
  min-height: 150px;
  position: relative;

  > div:nth-child(1) {
    position: absolute;
  }

  ${(props) => props.backgroundImage ? `
    background-image: url(${props.backgroundImage});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    transition: background-image 0.3s ease-in-out;
  ` : `
    background: ${props.backgroundColor || '#ccab0d'}
  `}
`;

export const StyledImagePlaceholder: any = styled.div`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 40%);
  max-width: 380px;
  width: 100%;
`;
interface ImageWrapperProps {
  isNewImage: string;
  isCustomImage: boolean;
}

export const StyledImageWrapper: any = styled.div<ImageWrapperProps>`
  position: relative;
  width: 100%;
  max-width: 380px;
  display: flex;
  justify-content: center;

  > img:nth-child(2) {
    margin-top: -20px;
    margin-bottom: 10px;
    min-with: 380px;
    max-with: 350px;
  }

  img {
    transition: opacity 0.4s ease-in-out;
  }
`;


export const StyledOfferBadge = styled.div`
  position: absolute;
  top: 7px;
  left: 10px;
`;
